module.exports = __webpack_public_path__ + "static/img/empresa.23dbeee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empresa.png
// module id = c020
// module chunks = 0